module.exports = __webpack_public_path__ + "img/vertical_4_2_7042.de0ca38c.png";